/**
 * Local login presets — keep in sync with
 * liwaza-backend/app/local_test_accounts.py
 */

export const LOCAL_SEED_PASSWORD = 'liwaza2026';

export const LOCAL_LOGIN_PRESETS = [
  {
    id: 'ielts-a1-premium',
    emoji: '🅰️',
    label: 'IELTS A1 Premium',
    detail: 'A1 → C1 · quiz Sundays',
    email: 'local.ielts.a1.premium@example.com',
    password: LOCAL_SEED_PASSWORD,
  },
  {
    id: 'ielts-b2-premium',
    emoji: '🅱️',
    label: 'IELTS B2 Premium',
    detail: 'B2 → C1 · mocks',
    email: 'local.ielts.b2.premium@example.com',
    password: LOCAL_SEED_PASSWORD,
  },
  {
    id: 'ielts-a1-free',
    emoji: '🆓',
    label: 'IELTS A1 Free',
    detail: 'PremiumRoute blocked',
    email: 'local.ielts.a1.free@example.com',
    password: LOCAL_SEED_PASSWORD,
  },
  {
    id: 'app-premium',
    emoji: '🌐',
    label: 'App Premium',
    detail: 'Full app · GRE + MBA + IELTS',
    email: 'local.app.premium@example.com',
    password: LOCAL_SEED_PASSWORD,
  },
  {
    id: 'e2e-unassessed',
    emoji: '🧪',
    label: 'E2E Unassessed',
    detail: 'Full app · no IELTS assessment',
    email: 'local.e2e.unassessed@example.com',
    password: LOCAL_SEED_PASSWORD,
  },
  {
    id: 'app-free',
    emoji: '🚪',
    label: 'App Free',
    detail: 'Full app · PremiumRoute blocked',
    email: 'local.app.free@example.com',
    password: LOCAL_SEED_PASSWORD,
  },
  {
    id: 'coach-reviewer',
    emoji: '📝',
    label: 'Review coach',
    detail: 'Document comments · /coach/document-reviews',
    email: 'local.coach.reviewer@example.com',
    password: LOCAL_SEED_PASSWORD,
  },
];

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

export function shouldShowLocalLoginPresets({
  nodeEnv = process.env.NODE_ENV,
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  forceFlag = process.env.REACT_APP_SHOW_LOCAL_LOGIN,
} = {}) {
  const flag = String(forceFlag || '').toLowerCase();
  if (flag === '0' || flag === 'false' || flag === 'off') return false;
  if (flag === '1' || flag === 'true' || flag === 'on') return true;
  return nodeEnv === 'development' && LOCAL_HOSTS.has(hostname);
}
